import "./styles.css";
import { useEffect, useState } from "react";
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableEvaluationRow from "./TableVisualizationRow/Index";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import InfoEvaluation from "../../Tasks/ViewTasks/InfoEvaluation";
import axios from "../../../services/axios";
import { IOptionsEvaluation } from "../../SystemManager/Monitoring/Tables/Index";
import { useFilter } from "../../../hooks/useFilter";
import { Loading } from "../../Loading/Index";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg";
import { useTableMonitor } from "../../../hooks/useTableMonitor";

interface TableProductsProps {
  listTable: IMicroAreaEvaluation[];
  filter: IOptionsEvaluation | undefined;
  isLoading: boolean;
}

export default function TableEvaluation({
  listTable,
  filter,
  isLoading,
}: TableProductsProps) {
  const {
    setDefaultValue,
    setIdSelected,
    setOptionForm,
  } = useEditOnboarding();
  const { setSystemManager } = useFilter();
  const { setModalStartEvaluator, modalStartEvaluator, startedEvaluation } =
    useTaskCreation();
  const [haveEvaluator, setHaveEvaluator] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } =
    useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt");
  }, []);

  useEffect(() => {
    axios.get(`users/user/evaluator`).then(({ data }) => {
      setHaveEvaluator(
        data.filter((el: any) => el.status == "ACTIVE").length > 0,
      );
    });
  }, [modalStartEvaluator]);

  const statusMap = new Map<string, string>();
  statusMap.set("COMPLETED", "Avaliado");
  statusMap.set("PENDING", "Pendente");
  statusMap.set("CANCELED", "Cancelada");
  statusMap.set("PENDING", "Pendente");
  statusMap.set("ERROR", "Erro");

  return (
    <>
      {!haveEvaluator ? (
        <div className="emptyTable_container">
          <span>
            Para iniciar a avaliação, é necessário alocar um responsável como
            avaliador.
          </span>
          <div
            className="addProduct_button"
            onClick={() => {
              setIdSelected(0);
              setDefaultValue(undefined);
              setSystemManager("MANAGER_EVALUATORS");
              setOptionForm("create-evaluator");
            }}
          >
            <PlusIcon />
            <span>Adicionar avaliador</span>
          </div>
        </div>
      ) : !startedEvaluation ? (
        <div className="emptyTable_container">
          <span>
            Inicie a avaliação para começar a visualizar os pastos avaliados.
          </span>
          <div
            className="addProduct_button"
            onClick={() => {
              setModalStartEvaluator(true);
            }}
          >
            <span>Iniciar avaliação</span>
          </div>
        </div>
      ) : listTable && listTable.length > 0 ? (
        <>
          <table
            className="tableTaskEvaluation"
            style={{ minWidth: 1366 }}
            id="tablePastureEvaluator"
          >
            <thead>
              <tr>
                {[
                  { key: "evaluator", label: "Usuário" },
                  { key: "microAreaInitials", label: "Pasto" },
                  { key: "status", label: "Status" },
                  {
                    key: "createdAt",
                    label: (
                      <div>
                        Data
                        <br />
                        Criação
                      </div>
                    ),
                  },
                  {
                    key: "updatedAt",
                    label: (
                      <div>
                        Data
                        <br />
                        Execução
                      </div>
                    ),
                  },
                ].map(({ label, key }) => (
                  <th
                    key={key}
                    onClick={() => {
                      setSelectedOrder(key);
                      if (selectedOrder !== key) {
                        setSortAsc(false);
                        return;
                      }
                      setSortAsc(!sortAsc);
                    }}
                  >
                    <div className="infoColumn">
                      {label}
                      <ArrowIcon
                        className={`iconSort${sortAsc ? "--asc" : ""}`}
                        style={{
                          display: selectedOrder === key ? "block" : "none",
                        }}
                      />
                    </div>
                  </th>
                ))}
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map((evaluation) => (
                <TableEvaluationRow
                  evaluation={evaluation}
                  setSelectedId={setSelectedId}
                />
              ))}
            </tbody>
          </table>

          {isLoading && (
            <div className="tableLoadingOverlay" style={{ minWidth: 1400 }}>
              <div className="lds-ring">
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="emptyTable_container">
          {filter ? (
            <span>
              Nenhum resultado encontrado para o estado {statusMap.get(filter)}.
            </span>
          ) : (
            <span> Nenhum resultado encontrado.</span>
          )}
        </div>
      )}
      <InfoEvaluation selected={selectedId} setSelectedId={setSelectedId} />
    </>
  );
}
